// Styles
import "./VCode.css";

// Utilities
import { createSimpleFunctional } from "../../util/index.js";
export const VCode = createSimpleFunctional('v-code', 'code');
//# sourceMappingURL=index.js.map